<template>
  <div>
    <topbar :title="$t('surveys.page-title')" />
    <div class="hidden h-12 md:block"></div>

    <div class="flex flex-col mx-auto max-w-3xl w-full md:px-3 xl:max-w-none xl:three-columns xl:grid">
      <card type="square" class="col-start-2 md:rounded-lg">
        <component :is="incompleteSurveys.includes(survey) ? 'router-link' : 'div'" :to="{name: 'Survey', params: {id: survey.id}}" v-for="survey of surveys" :key="survey.id" class="flex border-line border-b p-1 items-center">
          <div class="flex items-center justify-center p-4">
            <div class="flex justify-center items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45">
                <template v-if="!incompleteSurveys.includes(survey)">
                  <g fill="#a0a0a0"><path d="M22.7 4a18.7 18.7 0 1018.7 18.7A18.73 18.73 0 0022.7 4zm0 35.94A17.23 17.23 0 1139.93 22.7 17.25 17.25 0 0122.7 39.94z"/><path d="M31.96 15.83l-12.2 12.2-3.85-3.86a.74.74 0 00-1.04 1.04l4.37 4.38a.74.74 0 001.04 0L33 16.87a.74.74 0 00-1.04-1.04z"/></g>
                </template>
                <template  v-else>
                  <path d="M22.7 4a18.7 18.7 0 1018.7 18.7A18.73 18.73 0 0022.7 4zm0 35.94A17.23 17.23 0 1139.93 22.7 17.25 17.25 0 0122.7 39.94z"/><path d="M22.93 19.72a2.67 2.67 0 102.67 2.66 2.67 2.67 0 00-2.67-2.66zm0 3.85a1.19 1.19 0 111.19-1.19 1.19 1.19 0 01-1.19 1.19zM29.42 19.72a2.67 2.67 0 102.67 2.66 2.67 2.67 0 00-2.67-2.66zm0 3.85a1.19 1.19 0 111.19-1.19 1.19 1.19 0 01-1.19 1.19zM16.54 19.72a2.67 2.67 0 102.66 2.66 2.67 2.67 0 00-2.66-2.66zm0 3.85a1.19 1.19 0 111.18-1.19 1.19 1.19 0 01-1.18 1.19z"/>
                </template>
              </svg>
            </div>
          </div>
          <div class="flex-1">
            <div class="text-secondary_text">{{new Date(survey.date).toLocaleDateString('it-CH', { dateStyle: 'long' })}}</div>
            <div>{{survey.title}}</div>
          </div>
          <div v-if="incompleteSurveys.includes(survey)" class="pr-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45"><path d="M5 23.72h33.75l-8.71 8.72a.72.72 0 001.02 1.02l9.9-9.9a.88.88 0 000-1.12l-9.9-9.9a.72.72 0 00-1.02 1.02l8.71 8.71H5a.72.72 0 000 1.45z" fill="#e3064a"/></svg>
          </div>
        </component>
      </card>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState('surveys', {
      surveys: state => state.list,
      index: 'index'
    }),
    ...mapGetters('surveys', ['incompleteSurveys'])
  }
}
</script>

<style>

</style>